import { Grid, Stack, Typography } from "@mui/material";
import { useAuth } from "../../auth/context";

const DoctorInfo = () => {
  const { user } = useAuth();
  const {
    email,
    name,
    surname,
    documentNumber,
    specialty,
    title,
    licenseType,
    licenseNumber,
    address,
    province,
    workPhone,
  } = user;

  return (
    <Grid container spacing={0.5} sx={{ p: { xs: "0px 10px", sm: "0px 20px" } }}>
      <Grid item xs={12} sm={5}>
        <Typography>
          <strong>Nombre completo: </strong> {name} {surname}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={5}>
        <Typography>
          <strong>Título: </strong> {title}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={5}>
        <Typography>
          <strong>Especialidad: </strong> {specialty}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={5}>
        <Typography>
          <strong>Licencia: </strong>
          {licenseNumber} ({licenseType})
        </Typography>
      </Grid>

      <Grid item xs={12} sm={5}>
        <Typography>
          <strong>DNI: </strong> {documentNumber}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={5}>
        <Typography>
          <strong>Email: </strong> {email}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={5}>
        <Typography>
          {" "}
          <strong>Teléfono: </strong> {workPhone}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={5}>
        <Typography>
          <strong>Dirección: </strong> {address}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={5}>
        {province && (
          <Typography>
            <strong>Provincia: </strong> {province}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default DoctorInfo;
